/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-function-type */
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {Platform} from 'react-native';
import {
  IValidate,
  validate,
} from '../../common/utils/validationContratRattacher';
import {
  autoPhotoLabels,
  initErrors,
  initHideErrors,
  initShowErrors,
  initValues,
} from '../../data/constants/Contrats/contratRattacher';
import {ApiResponse} from '../../data/types/interface/api';
import {
  IErrors,
  IShowErrors,
  IValues,
} from '../../data/types/interface/Contrats/contratRattacher';
import {ContratRattacherService} from '../../services/applicatif/contrat';
import {IPostTarifAutoResponse} from '../../services/bdl/contrat';
import {addPhotosToFormData} from './utils';

dayjs.extend(customParseFormat);
export const useContratRattached = (
  saveLocal: Function,
  numeroPolice: string,
  onSubmit: Function,
  onClose: Function,
  user: any,
  type: string = '',
  dateEcheance: string,
) => {
  const [values, setValues] = React.useState<IValues>(initValues);
  const [errors, setErrors] = React.useState<IErrors>(initErrors);
  const [showErrors, setShowErrors] =
    React.useState<IShowErrors>(initHideErrors);
  const [loadingAmount, setLoadingAmount] = React.useState<boolean>(false);
  const [loadingSubmit, setLoadingSubmit] = React.useState<boolean>(false);
  const [isSubmited, setIsSubmited] = React.useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string | undefined>(
    undefined,
  );

  const clearErrorMessage = useCallback(() => setErrorMessage(undefined), []);

  const {
    getMontant,
    renouvellerContratRattache,
    renouvellerContratAuto,
    getMontantAuto,
  } = ContratRattacherService();

  const arePhotosRequired = useMemo(() => {
    console.log(dateEcheance, values.garanties);

    const hasOtherGaranties = (values.garanties ?? []).some(
      (g: {code: string}) => g.code != 'RARC',
    );

    return (
      dayjs().isAfter(dayjs(dateEcheance, 'DD/MM/YYYY'), 'day') &&
      hasOtherGaranties
    );
  }, [dateEcheance, values.garanties]);

  useEffect(() => {
    console.log(type, 'requiredPhoto', arePhotosRequired);

    setValues(prev => ({...prev, arePhotosRequired}));
  }, [arePhotosRequired]);

  const handleSubmit = async () => {
    setLoadingSubmit(true);
    // validate values
    const status: IValidate = validate(values, type, arePhotosRequired);
    setErrors(status.errors);
    setShowErrors(initShowErrors);
    if (!status.isError) {
      try {
        let resSubmit: ApiResponse;
        if (type == 'auto') {
          const formData = new FormData();
          formData.append('numeroPolice', numeroPolice);
          formData.append('utilisateur', user?.data?.utilisateur?.id);
          formData.append('primeTTC', values.amount.toString());
          formData.append(
            'dateEffet',
            dayjs(values.dateDebut).format('YYYY-MM-DD'),
          );
          formData.append('duration', values.duration);
          formData.append('operationType', 'simulation');
          formData.append('simulationId', '');
          formData.append('acceptTerm', values.acceptTerm ? 'true' : 'false');

          await addPhotosToFormData(values, formData);

          const res = await renouvellerContratAuto(formData);
          if (res.isError) {
            resSubmit = res;
          } else {
            resSubmit = res.data;
          }
        } else {
          resSubmit = await renouvellerContratRattache({
            numeroPolice: numeroPolice,
            primeTTC: values.amount.toString(),
            dateEffet: dayjs(values.dateDebut).format('DD/MM/YYYY'),
            duration: parseInt(values.duration),
            operationType: 'simulation',
            simulationId: '',
            utilisateur: user?.data?.utilisateur?.id,
          });
        }

        if (resSubmit.isError || resSubmit.error) {
          setLoadingSubmit(false);
          setErrorMessage(resSubmit.message);
        } else {
          saveLocal({
            simulationId: String(resSubmit.data),
            montant: String(values.amount),
            dateEffet:
              typeof values.dateDebut == 'string'
                ? dayjs(values.dateDebut, 'DD/MM/YYYY').toDate()
                : values.dateDebut,
            typeContrat: type == 'auto' ? 'auto' : 'rattache',
            operationType: 'create',
            typePayment: 'renouvellement',
            utilisateur: user?.data?.utilisateur?.id,
            numeroPolice,
          });
          setIsSubmited(() => true);
          setLoadingSubmit(false);
        }
      } catch (error) {
        console.log(error);
        setLoadingSubmit(false);
        setErrorMessage(
          (error as any).message ||
            "Une erreur s'est produite. Veuillez réessayer.",
        );
      }
    }
    setLoadingSubmit(() => false);
  };

  React.useEffect(() => {
    if (
      user?.contratEC?.numeroPolice === numeroPolice &&
      !validate(values, type, arePhotosRequired).isError &&
      isSubmited
    ) {
      setIsSubmited(() => false);
      onClose();
      onSubmit();
    }
  }, [user?.contratEC, isSubmited]);

  const handleChange = async (
    name: keyof IValues,
    value: IValues[typeof name],
    remove: boolean = false,
  ) => {
    let _value = value;

    if (autoPhotoLabels.find(p => p.name === name)) {
      if (_value === 'INVALID INPUT') {
        setValues({...values, [name]: []});
      } else {
        if (Platform.OS !== 'web' && !remove) {
          _value = {
            uri: value.uri,
            type: value.type,
            name: value.fileName,
          };
        }
        if (remove) {
          setValues((oldValues: IValues) => ({...oldValues, [name]: _value}));
        } else {
          const images = [...values[name]];
          images.push(_value);
          setValues({...values, [name]: images});
        }
      }
    } else {
      setValues((oldValues: IValues) => ({...oldValues, [name]: _value}));
    }
  };

  useEffect(() => {
    const calculateAmount = async () => {
      const needAmount =
        type == 'auto'
          ? !!values.dateDebut
          : values.dateDebut && values.duration;
      if (needAmount) {
        setLoadingAmount(() => true);
        let retries = 0;
        const totalRetry = 2;

        let resTarif: ApiResponse<any> | undefined = undefined;
        while (retries < totalRetry) {
          try {
            if (type == 'auto') {
              resTarif = await getMontantAuto({
                policyNumber: numeroPolice,
                startDate: dayjs(values.dateDebut).format('YYYY-MM-DD'),
              });
            } else {
              resTarif = await getMontant({
                duration: values.duration,
                policyNumber: numeroPolice,
                startDate: dayjs(values.dateDebut).format('YYYY-MM-DD'),
              });
            }
            if (resTarif && resTarif?.data) {
              setValues((oldValues: IValues) => ({
                ...oldValues,
                amount: String(
                  Math.ceil(
                    type == 'auto'
                      ? resTarif?.data.primeTTC
                      : resTarif?.data?.prime,
                  ),
                ),
                garanties:
                  type == 'auto'
                    ? (resTarif?.data as IPostTarifAutoResponse).garanties
                    : [],
              }));
              break;
            } else {
              retries++;
            }
          } catch (error) {
            console.log(error);
            retries++;
            if (retries < totalRetry) {
              await new Promise(resolve => setTimeout(resolve, 1000));
            }
          }
        }
        setLoadingAmount(() => false);
        if (resTarif && resTarif?.isError) {
          setErrorMessage(() => resTarif?.message);
        }
      }
    };

    calculateAmount();
  }, [values.dateDebut, values.duration]);

  const arePhotosEmpty = useMemo(
    () =>
      values.vehiculeImageAvant?.length == 0 ||
      values.vehiculeImageArriere?.length == 0 ||
      values.vehiculeImageDroite?.length == 0 ||
      values.vehiculeImageGauche?.length == 0 ||
      values.vehiculeBatterieImage?.length == 0,
    [
      values.vehiculeImageAvant,
      values.vehiculeImageArriere,
      values.vehiculeImageDroite,
      values.vehiculeImageGauche,
      values.vehiculeBatterieImage,
    ],
  );

  const isEmpty = useMemo(() => {
    if (type == 'auto') {
      if (arePhotosRequired) {
        return !Boolean(
          values.amount &&
            values.dateDebut &&
            values.acceptTerm &&
            !arePhotosEmpty,
        );
      } else {
        return !Boolean(values.amount && values.dateDebut && values.acceptTerm);
      }
    }
    return !Boolean(values.amount && values.duration && values.dateDebut);
  }, [values, type, arePhotosEmpty]);

  return {
    values,
    handleChange,
    handleSubmit,
    loadingAmount,
    loadingSubmit,
    errors,
    showErrors,
    isEmpty,
    errorMessage,
    clearErrorMessage,
  };
};
